// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@4.3.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grid-list-megapopup__backdrop{background-color:#000;height:100vh;left:0;opacity:.5;position:fixed;top:0;width:100vw;z-index:1000}.grid-list-megapopup__popup{background-color:#f6f6f6;border-left:1px solid #bbb;left:0;position:absolute;top:0;z-index:1001}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
